import { h } from 'vue';
import type { IconOptions, IconProps, IconSet } from 'vuetify';
import { VSvgIcon } from 'vuetify/components/VIcon';
import { aliases } from 'vuetify/iconsets/mdi-svg';
// Relative import: this module is shared with the VitePress theme (docs/.vitepress/theme), which has no `~` alias.
import { MDI_ICONS } from './mdi-icons.generated';

/**
 * Icons keep their MDI names (mdi-*) in templates but render as inline SVG from @mdi/js, so only the
 * icons the site uses are shipped instead of the whole MDI webfont and its CSS.
 * New icon: `npx tsx scripts/generate-mdi-icons.ts`.
 */
const mdiByName: IconSet = {
  component: (props: IconProps) => {
    const name = String(props.icon);
    if (import.meta.env?.DEV && !MDI_ICONS[name]) {
      console.warn(`[vuetify] icon "${name}" is not generated; run npx tsx scripts/generate-mdi-icons.ts`);
    }
    return h(VSvgIcon, { ...props, icon: MDI_ICONS[name] ?? '' });
  },
};

/** `icons` option of createVuetify() for the site and the documentation. */
export const vuetifyIcons: IconOptions = {
  defaultSet: 'mdi',
  aliases,
  sets: { mdi: mdiByName },
};
